import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { message } from 'antd'
import { useEffect, useState } from 'react'

import { adminLogin, isAuthenticated, logout } from '../services/authService'

// 登录钩子
export function useLogin() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: adminLogin,
    onSuccess: () => {
      message.success('登录成功')
      // 清除所有查询缓存，重新获取用户相关数据
      queryClient.clear()
      // 强制刷新页面以确保状态更新
      window.location.href = '/'
    },
    onError: (error) => {
      message.error(error.message || '登录失败')
    },
  })
}

// 退出登录钩子
export function useLogout() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      logout()
    },
    onSuccess: () => {
      message.success('已退出登录')
      // 清除所有查询缓存
      queryClient.clear()
      // 跳转到登录页
      navigate({ to: '/login' })
    },
  })
}

// 检查认证状态 - 使用状态来确保组件重新渲染
export function useAuth() {
  const [authenticated, setAuthenticated] = useState(isAuthenticated())
  const navigate = useNavigate()

  useEffect(() => {
    // 监听 storage 变化
    const handleStorageChange = () => {
      setAuthenticated(isAuthenticated())
    }

    // 监听自定义token过期事件
    const handleTokenExpired = () => {
      setAuthenticated(false)
      // 立即跳转到登录页面
      navigate({ to: '/login' })
    }

    window.addEventListener('storage', handleStorageChange)
    window.addEventListener('tokenExpired', handleTokenExpired)

    // 定期检查认证状态
    const interval = setInterval(() => {
      const currentAuth = isAuthenticated()

      if (authenticated !== currentAuth) {
        setAuthenticated(currentAuth)
        if (!currentAuth) {
          navigate({ to: '/login' })
        }
      }
    }, 1000)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
      window.removeEventListener('tokenExpired', handleTokenExpired)
      clearInterval(interval)
    }
  }, [authenticated, navigate])

  return {
    isAuthenticated: authenticated,
  }
}

// 全局token过期处理函数
export function handleGlobalTokenExpired() {
  // 清除本地存储的tokens
  localStorage.removeItem('access_token')
  localStorage.removeItem('refresh_token')
  localStorage.removeItem('token') // 清理旧token

  // 触发自定义事件，通知所有监听器
  window.dispatchEvent(new Event('tokenExpired'))

  // 显示提示信息
  message.error('登录已过期，请重新登录')

  // 检查当前页面是否已经是登录页，避免不必要的跳转
  if (window.location.pathname !== '/login') {
    window.location.href = '/login'
  }
}
